import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-tax-adviser-finish-dialog',
    templateUrl: './tax-adviser-finish-dialog.component.html',
    styleUrls: ['./tax-adviser-finish-dialog.component.scss'],
    standalone: false
})
export class TaxAdviserFinishDialogComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<TaxAdviserFinishDialogComponent>) { }

  ngOnInit() {
  }

  public close(){
    this.dialogRef.close();
  }
}
